(function () {
  function getEndOfDay(date) {
    var d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }

  function parseDateString(str) {
    if (!str || typeof str !== 'string') return null;
    var parts = str.trim().split('-');
    if (parts.length !== 3) return null;
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);
    if (isNaN(y) || isNaN(m) || isNaN(day)) return null;
    var parsed = new Date(y, m, day);
    if (parsed.getFullYear() !== y || parsed.getMonth() !== m || parsed.getDate() !== day) return null;
    return parsed;
  }

  function getTargetTime(endDateStr) {
    var now = Date.now();
    if (endDateStr && endDateStr.trim() !== '') {
      var parsed = parseDateString(endDateStr);
      if (parsed) return getEndOfDay(parsed);
    }
    var today = new Date();
    return getEndOfDay(today);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function updateTimer(container, targetTime, endDateStr) {
    var now = Date.now();
    var diff = targetTime - now;

    if (diff <= 0) {
      if (endDateStr && endDateStr.trim() !== '') {
        container.querySelector('[data-timer-hours]').textContent = '00';
        container.querySelector('[data-timer-minutes]').textContent = '00';
        container.querySelector('[data-timer-seconds]').textContent = '00';
        return;
      }
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      targetTime = getEndOfDay(tomorrow);
      diff = targetTime - Date.now();
    }

    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    container.querySelector('[data-timer-hours]').textContent = pad(hours);
    container.querySelector('[data-timer-minutes]').textContent = pad(minutes);
    container.querySelector('[data-timer-seconds]').textContent = pad(seconds);
  }

  function runTimer(container) {
    var endDateStr = container.getAttribute('data-end-date') || '';
    var targetTime = getTargetTime(endDateStr);

    updateTimer(container, targetTime, endDateStr);
    setInterval(function () {
      var now = Date.now();
      if (now >= targetTime && endDateStr && endDateStr.trim() !== '') {
        updateTimer(container, targetTime, endDateStr);
        return;
      }
      if (now >= targetTime && !endDateStr) {
        targetTime = getEndOfDay(new Date(new Date().setDate(new Date().getDate() + 1)));
      }
      updateTimer(container, targetTime, endDateStr);
    }, 1000);
  }

  document.querySelectorAll('[data-timer]').forEach(runTimer);
})();
